import _ from "lodash"
import { ImmutableBehaviorSubject as BehaviorSubject } from "data/lib/immutable-behavior-subject"

// private module logic //

interface CarouselObj {
  controls: object,
  field: string,
  namedItems?: object,
  persist: Function,
  rowData: object,
  show: boolean,
  title: string,
  description?: string
  table?: string
}

const initialState = {
  controls: {},
  field: "",
  namedItems: {},
  persist: () => {},
  rowData: {},
  show: false,
  title: ""
}

const carouselStream = new BehaviorSubject<CarouselObj>(initialState);

function noneState(state = {state: 'none'}):void {
  const currentValue:object = carouselStream.getValue();
  currentValue['persist'](state, currentValue['field'], currentValue['rowData']);
}

function updateData(data: CarouselObj):void {
  carouselStream.next(data);
}

function updateRowData(rowData:object):void {
  const currentValue:CarouselObj = carouselStream.getValue();
  carouselStream.next({...currentValue, rowData});
}

function toggleShow(show: boolean):void {
  show === false ? carouselStream.next(initialState) : carouselStream.next({...carouselService.value(), show})
}

// public module interface //

const carouselService = {
  noneState: (state: any) => noneState(state),
  stream: () => carouselStream.asObservable(),
  value: () => carouselStream.getValue(),
  toggleShow: (show:boolean) => toggleShow(show),
  updateData: (data:CarouselObj) => updateData(data),
  updateRowData: (rowData:object) => updateRowData(rowData)
}

export default carouselService
